import { getI18nKeyByIp } from '@/apis/i18n';
import { I18nKey } from '@/i18n/types';
import { DeviceType } from '@/utils/device-type/types';
import { checkI18nKey, getI18nKeyByBrowser, loadI18nAsync } from '@/utils/i18n';
import { defineStore } from 'pinia';
import { ref } from 'vue';

const useAppStore = defineStore('app', () => {
  // ==================================================
  // state
  // ==================================================
  // i18nKey
  const i18nKey = ref<I18nKey>(getI18nKeyByBrowser());
  // i18nKeyByIp
  const i18nKeyByIp = ref<I18nKey>(getI18nKeyByBrowser());
  // deviceType
  const deviceType = ref<DeviceType>('DESKTOP');
  // initDataComplete
  const initDataComplete = ref<boolean>(false);

  // ==================================================
  // actions
  // ==================================================
  const updateI18nKey = (i18nKey_: typeof i18nKey.value) => {
    i18nKey.value = i18nKey_;
  };
  const updateI18nKeyAsync = async (i18nKey_: typeof i18nKey.value) => {
    await loadI18nAsync(i18nKey_);
    updateI18nKey(i18nKey_);
  };
  const updateI18nKeyByIp = (i18nKeyByIp_: typeof i18nKeyByIp.value) => {
    i18nKeyByIp.value = i18nKeyByIp_;
  };
  const updateI18nKeyByIpAsync = async () => {
    const result = await getI18nKeyByIp();
    // 这里需要做判断: 如果后端返回的数据有问题, 就根据浏览器语言进行设置, 这一步保证前端不会出错
    // @ts-ignore
    updateI18nKeyByIp(checkI18nKey(result) ? result : getI18nKeyByBrowser());
  };
  const updateDeviceType = (deviceType_: typeof deviceType.value) => {
    deviceType.value = deviceType_;
  };
  const updateInitDataComplete = (initDataComplete_: typeof initDataComplete.value) => {
    initDataComplete.value = initDataComplete_;
  };

  return {
    i18nKey,
    i18nKeyByIp,
    deviceType,
    initDataComplete,
    updateI18nKey,
    updateI18nKeyAsync,
    updateI18nKeyByIp,
    updateI18nKeyByIpAsync,
    updateDeviceType,
    updateInitDataComplete,
  };
});

export { useAppStore };
